import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react'
import { VariantProps, cva } from 'class-variance-authority'
import { cx } from 'tusk-ui/utils'
import { ElementPrimitive } from 'tusk-ui'

const chipVariants = cva('rounded-full bg-gum-200', {
    variants: {
        size: {
            sm: 'p-4',
            md: 'px-12 py-4',
            lg: 'py-12 px-20'
        }
    },
    defaultVariants: {
        size: 'md'
    }
})

interface CardProps extends ComponentPropsWithoutRef<typeof ElementPrimitive.Div>, VariantProps<typeof chipVariants> {}

const Card = forwardRef<ElementRef<typeof ElementPrimitive.Div>, CardProps>((props, ref) => {
    const { className, size, ...restProps } = props

    return <ElementPrimitive.Div ref={ref} className={cx(chipVariants({ size }), className)} {...restProps} />
})

export default Card
